import type { MessageDescriptor } from 'react-intl-next';

export const CONTENT_STATUS_ARCHIVED = 'archived';
export const ARCHIVE_INTL_PREFIX: string = 'ARCHIVE_';
export const UNARCHIVE_INTL_PREFIX: string = 'UNARCHIVE_';
export const ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT: number = 180;
export const ARCHIVE_PAGES_WITH_NOTE_INCREASED_CHARACTER_LIMIT: number = 255;

// The following constant is a copy of the same constant defined in @confluence/manage-pages,
// but we can't import it from there because that will cause a circular dependency.  If you change
// it here, please change it in @confluence/manage-pages to keep them consistent!
export const BULK_ARCHIVE_PAGE_SELECTION_LIMIT = 500;

export enum ArchiveStatus {
	LOADING = 'loading',
	ERROR = 'error',
	SUCCESS = 'success',
}

export type ArchiveStatusFlagI18n = {
	getErrorMessage: (error?: Error) => MessageDescriptor;
	successTitle: MessageDescriptor;
	successLink: MessageDescriptor;
	errorTitle: MessageDescriptor;
	loadingTitle: MessageDescriptor;
};

export const PAGE_RESTRICTIONS_SUPPORT_LINK =
	'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
export const PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK =
	'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
export const ARCHIVE_PERMISSIONS_SUPPORT_LINK =
	'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
export const UNARCHIVE_PERMISSIONS_SUPPORT_LINK =
	'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
